"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getTotalClipsDuration;

function getTotalClipsDuration(clips) {
  return clips.reduce(function (time, clip) {
    return time + clip.duration;
  }, 0);
}